module.exports = __webpack_public_path__ + "static/media/Twemoji12 1f600.7c010dc6.svg";